import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import {
    Button,
    Stack,
    Box,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    TextField,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Tooltip
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { CustomTitle, handleSessionOut, Loader } from "../HelperFunctions/HelperFunctions";
import CorporationSelectDialog from "./CorporationSelectDialog";
import { fetchCustomizeData, deleteCustomizeOptReport } from "../API/backend";
import { enqueueSnackbar } from "notistack";
import CustomizeDialog from './CustomizeDialog';
import { useLoaderData } from "react-router-dom";
import { getCorporationsByMgntGrp } from "../API/nimbleAPI";

const ReportsViewer = ({ slide, setSlide, onClose, isEdit }) => {
    const { values, handleChange, setFieldValue, resetForm } = useFormikContext();
    // console.log("valuesvalues", values)
    const { token, corpId, clientID, UID } = useLoaderData();
    const [corpDialog, setCorpDialog] = useState(false);
    const [loading, setLoading] = useState(false)
    const [reportTableData, setReportTableData] = useState([]);
    const [customizationOpen, setCustomizationOpen] = useState(false);
    const [corporationCount, setCorporationCount] = useState(false);

    useEffect(() => {
        getReportBookTableData()
    }, []);

    useEffect(() => {
        if (!isEdit && values.selected_corporations.length <= 0 && corpId !== "000000000000000000000000000000000000") {
            setFieldValue("selected_corporations", [corpId])
        }
        else if (!isEdit && values.selected_corporations.length <= 0 && corpId == "000000000000000000000000000000000000") {
            getCorporation("ALL")
        }
        else if (isEdit) {
            getCorporation(values.corp_management_groups, true)
        }

    }, []);

    const getCorporation = async (valueCode, getList = false) => {
        setLoading(true);
        try {

            const corporations = await getCorporationsByMgntGrp(valueCode);
            const corporationIds = await corporations.map(item => item.CorporationID);
            setFieldValue("cropCount", corporationIds.length);
            if (getList) {
                setCorporationCount(corporationIds.length);
                setLoading(false);
                return;
            }
            setFieldValue("selected_corporations", corporationIds);
            setCorporationCount(corporationIds.length);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            enqueueSnackbar("Error while getting corporation details", {
                variant: "error",
            });
        }
    };

    useEffect(() => {
        if (Object.entries(values.customization).length == 0) {
            getCustomizedData()
        }
    }, [])

    const getReportBookTableData = async () => {

        try {
            setLoading(true)

            const { reportsViewerData, checkedItems } = values;
            const filteredSchedules = reportsViewerData["schedules"].filter(
                (item) => checkedItems[item.report]
            );
            setReportTableData(filteredSchedules)

        } catch (error) {
            console.log(error)
            enqueueSnackbar("Error while getting the data", { variant: "error" })

        } finally {
            setLoading(false);
        }

    };

    // const getCustomizedData = async (data, clicked = false) => {
    const getCustomizedData = async () => {
        setLoading(true);

        try {
            const { client_id, schedule_id } = values;
            const customizeData = await fetchCustomizeData(client_id, schedule_id);
            setFieldValue("customization", customizeData.data);

        } catch (error) {
            if (error.status === 401) {
                await handleSessionOut()
            } else {
                enqueueSnackbar("Error while getting data", { variant: "error" })
            }
        } finally {
            setLoading(false);
        }


    };

    const deleteCustomeReports = async (data) => {
        setLoading(true);
        try {

            const { schedule_id } = data;
            const client_id = values.client_id;
            const deleteReport = await deleteCustomizeOptReport(client_id, schedule_id)
            if (deleteReport.status === 200) {
                setReportTableData(prevData =>
                    prevData.filter(row => row.schedule_id !== data.schedule_id)
                );
                setLoading(false);
            }

        } catch (error) {
            if (error.status === 401) {
                await handleSessionOut()
            } else {
                enqueueSnackbar("Error while delete report", { variant: "error" })
            }
            setLoading(false);
        }
    }

    const handleCustomeLayout = (layout) => {
        setFieldValue("customization", layout);
        // setCustomeData(null)
        setCustomizationOpen(false)

    }

    const handleNext = () => {
        if (
            Object.entries(values.customization).length == 0
            ||
            values.selected_corporations == 0
            ||
            values.selected_reports.length == 0
        ) {
            if (Object.entries(values.customization).length == 0) {
                enqueueSnackbar("Please select Cutomize", { variant: "info" })
            }
            else if (values.selected_reports.length == 0) {
                enqueueSnackbar("please select report for schedule", { variant: "info" })
            }
            else {
                enqueueSnackbar("Please select Corporation", { variant: "info" })
            }
            return;
        }
        setSlide(slide + 1)

    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setFieldValue("selected_reports", reportTableData.map(row => row.report_id));
        } else {
            setFieldValue("selected_reports", []);
        }
    };

    const handleToggle = (report_id) => {
        const selected = values.selected_reports;
        if (selected.includes(report_id)) {
            setFieldValue(
                "selected_reports",
                selected.filter(id => id !== report_id)
            );
        } else {
            setFieldValue("selected_reports", [...selected, report_id]);
        }
    };


    const columns = [
        { name: "report", width: "120px" },
        { name: "report_type", width: "120px" },
        { name: "account", width: "120px" },
        { name: "format_type", width: "110px" },
        { name: "actions", width: "60px" },
    ];

    return (
        <>
            <DialogContent sx={{ p: 0 }}>
                <Box p={1} bgcolor={"white"}>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap={1}>
                        <Stack gap={2} direction={"row"} >

                            <TextField
                                sx={{ minWidth: 200 }}
                                // size="small"
                                label="Report Book Name"
                                variant="standard"
                                name="reportBookName"
                                value={values.reportBookName}
                                onChange={handleChange}
                                InputProps={{ readOnly: true }}
                            />

                            <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1, }}>
                                <InputLabel id="bulk-action-label">Report Book Type</InputLabel>
                                <Select
                                    size="small"
                                    label="Report Book Type"
                                    name="reviewReportBookType"
                                    value={values.reviewReportBookType}
                                    onChange={handleChange}
                                    inputProps={{ readOnly: true }}
                                >
                                    {/* <MenuItem value="periodic_reports">Periodic Reports</MenuItem> */}
                                    <MenuItem value="custom_reports">Custom Reports</MenuItem>
                                </Select>
                            </FormControl>
                            {values.reviewReportBookType === "periodic_reports" &&
                                <FormControl sx={{ minWidth: 150, maxWidth: 280, m: 1, }}>
                                    <InputLabel id="bulk-action-label">Report Frequency</InputLabel>
                                    <Select
                                        size="small"
                                        label="Report Frequency"
                                        name="reviewReportFrequency"
                                        value={values.reviewReportFrequency}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="weekly">Weekly</MenuItem>
                                        <MenuItem value="semi_monthly">Semi - Monthly</MenuItem>
                                        <MenuItem value="monthly">Monthly</MenuItem>
                                        <MenuItem value="Quarterly">Quarterly</MenuItem>
                                        <MenuItem value="half_yearly">Half Yearly</MenuItem>
                                        <MenuItem value="yearly">Yearly </MenuItem>
                                    </Select>
                                </FormControl>
                            }
                            <Tooltip title="select corporation" arrow>
                                <TextField
                                    sx={{
                                        mt: 1,
                                        minWidth: 220,
                                        backgroundColor: "transparent",
                                        // cursor: "pointer",
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "transparent",
                                            maxHeight: "33px",
                                            fontSize: "13px",
                                            bgcolor: "#f5f5f5",
                                            fontWeight: 500,
                                            cursor: "pointer",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                            cursor: "pointer",
                                        }

                                    }}
                                    size="small"
                                    label="Corporation"
                                    // variant="standard"
                                    onClick={() => setCorpDialog(true)}
                                    name="corporation"
                                    value={
                                        values.selected_corporations.length === (corporationCount && corporationCount > 0 ? corporationCount : values.cropCount) ? "All_corporation(s)selected"
                                            :
                                            values.selected_corporations.length > 9
                                                ? `${values.selected_corporations.length}_corporation(s)selected`
                                                : values.selected_corporations.length > 0
                                                    ? `0${values.selected_corporations.length}_corporation(s)selected`
                                                    : "00_corporation(s)selected"
                                    }
                                    onChange={handleChange}
                                    InputProps={{ readOnly: true }}

                                />
                            </Tooltip>


                        </Stack>
                        <Box>
                            <Stack direction={"row"} gap={3}>

                                <Button
                                    variant="contained"
                                    size='small'
                                    disableElevation
                                    disableRipple

                                    sx={{
                                        px: 4,
                                        textTransform: "none",
                                        backgroundColor: "#b5dcf2",
                                        color: "#000",
                                        fontWeight: 400
                                    }}
                                    // onClick={onClose}
                                    onClick={() => {
                                        setSlide(slide - 1)
                                        resetForm();
                                        onClose();

                                    }}
                                >
                                    Close
                                </Button>

                                <Button
                                    variant="contained"
                                    size='small'
                                    disableElevation
                                    disableRipple

                                    sx={{
                                        px: 3,
                                        textTransform: "none",
                                        backgroundColor: "#b5dcf2",
                                        color: "#000",
                                        fontWeight: 400,
                                    }}
                                    onClick={() => setSlide(slide - 1)}
                                // type="submit"
                                >
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    size='small'
                                    disableElevation
                                    disableRipple

                                    sx={{
                                        // px: 3,
                                        textTransform: "none",
                                        backgroundColor: "#b5dcf2",
                                        color: "#000",
                                        fontWeight: 400,
                                        minWidth: "100px"
                                    }}
                                    // onClick={() => setSlide(slide + 1)}
                                    onClick={handleNext}
                                >
                                    Save & Next
                                </Button>

                            </Stack>
                        </Box>
                    </Stack>
                    <Box height={"530px"} mt={3}>

                        <TableContainer sx={{ border: "1px solid #f2f2f2", maxHeight: "560px", minWidth: "950px" }} >
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ "& .MuiTableCell-stickyHeader": { bgcolor: "#d7d7d7" } }}>
                                        <TableCell width="1px" sx={{ padding: "1px", borderRight: "1px solid white" }}>
                                            {/* <Checkbox size="small" color="grey" disableRipple /> */}
                                            <Checkbox
                                                size="small"
                                                color="grey"
                                                disableRipple
                                                checked={
                                                    values.selected_reports.length === reportTableData.length &&
                                                    reportTableData.length > 0
                                                }
                                                indeterminate={
                                                    values.selected_reports.length > 0 &&
                                                    values.selected_reports.length < reportTableData.length
                                                }
                                                onChange={handleSelectAll}
                                            />
                                        </TableCell>
                                        {columns.map((column, index) => (
                                            <TableCell

                                                align={column.name === "actions" ? "center" : "left"}
                                                key={index}
                                                width={column.width}
                                                sx={{ borderRight: "1px solid white", padding: 1, fontSize: "13px", fontWeight: 500 }}
                                            >
                                                {CustomTitle(column.name)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {reportTableData?.map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell sx={{ padding: "1px", borderRight: "1px solid #f2f2f2" }}>
                                                {/* <Checkbox size="small" color="grey" disableRipple /> */}
                                                <Checkbox
                                                    size="small"
                                                    color="grey"
                                                    disableRipple
                                                    checked={values.selected_reports.includes(row.report_id)}
                                                    onChange={() => handleToggle(row.report_id)}
                                                />
                                            </TableCell>

                                            {columns.slice(0, 4).map((column, colIndex) => (
                                                <TableCell
                                                    key={colIndex}
                                                    sx={{
                                                        borderRight: "1px solid #f2f2f2",
                                                        padding: "10px",
                                                        fontSize: "12px",
                                                        maxWidth: column.width,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {/* <Tooltip title={row[column.name] || "-"} arrow>
                                                        <span>{row[column.name] || "-"}</span>
                                                    </Tooltip> */}

                                                    <Tooltip title={(column.name === "format_type" ? values.customization.layout_settings?.export : row[column.name]) || "-"} arrow>
                                                        <span>
                                                            {column.name === "format_type"
                                                                ? values.customization.layout_settings?.export || "-"
                                                                : row[column.name] || "-"}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                            ))}

                                            <TableCell
                                                sx={{
                                                    maxWidth: "60px",
                                                    minWidth: "60px",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                >
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        disableElevation
                                                        disableRipple
                                                        sx={{
                                                            textTransform: "none",
                                                            backgroundColor: "#14eed4",
                                                            color: "#ffffff",
                                                            fontWeight: 700,
                                                            fontSize: "10px",
                                                        }}
                                                        // onClick={() => getCustomizedData(row, true)}
                                                        onClick={() => setCustomizationOpen(true)}

                                                    >
                                                        Customize
                                                    </Button>

                                                    <IconButton
                                                        // onClick={() => deleteCustomeReports(row)}
                                                        size="small">
                                                        <DeleteIcon sx={{ color: "#00efd1" }} />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>

                                        </TableRow>
                                    ))



                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Box>

                </Box>
            </DialogContent>
            <Loader loading={loading} />
            {corpDialog && <CorporationSelectDialog open={corpDialog} onClose={() => setCorpDialog(false)} corpCount={setCorporationCount} />}
            {customizationOpen && Object.entries(values.customization).length > 0 &&
                <CustomizeDialog
                    open={customizationOpen}
                    onClose={() => setCustomizationOpen(false)}
                    data={values.customization}
                    handleCustomeLayout={handleCustomeLayout}
                />
            }
        </>
    );
}

export default ReportsViewer;